import React from "react";
import { Box } from "@mui/material";
import Div from "@jumbo/shared/Div";
import ContentDetails from "./ContentDetails";
import CodeSnippets from "./CodeSnippets";
import { HEIGHT_OFFSET } from "app/utils/constants/constants";

const ContentPanel = ({
  content,
  codeTabValue,
  setCodeTabValue,
  setCode,
  setEditorLanguage,
}) => {
  const activeDetails = content?.contentDetails.filter((d) => d.active) || [];

  return (
    <Div sx={{ display: "flex", height: "100%", overflowY: "auto" }}>
      {content && (
        <Box
          sx={{
            p: 2,
            width: "100%",
            height: `calc(100vh - ${HEIGHT_OFFSET.PROGRAMMING_CONTENT})`,
          }}
        >
          <ContentDetails details={activeDetails} content={content} />
          <CodeSnippets
            activeDetails={activeDetails}
            codeTabValue={codeTabValue}
            setCodeTabValue={setCodeTabValue}
            setCode={setCode}
            setEditorLanguage={setEditorLanguage}
          />
        </Box>
      )}
    </Div>
  );
};

export default ContentPanel;
